var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTriangleArrowRightGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 11,
    viewBox: "0 0 8 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-9.18363e-08 9.89903C-5.50298e-08 10.7411 0.977078 11.2061 1.63059 10.6751L7.04478 6.27611C7.53733 5.87592 7.53733 5.12408 7.04478 4.72389L1.63059 0.324856C0.977076 -0.206124 -5.13218e-07 0.258937 -4.76412e-07 1.10097L-9.18363e-08 9.89903Z",
    fill: "#747B8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleArrowRightGrey);
export default __webpack_public_path__ + "static/media/triangle-arrow-right-grey.9fa065b2168cde90f0b0fc8aa508635f.svg";
export { ForwardRef as ReactComponent };